export default __webpack_public_path__ + "static/media/icon_twitter.974af9d8.svg";